import { Where, IFilter } from 'types/common'
import { api, handleError } from 'API'
import { IFavorite, IFavoriteWithRelations } from 'interfaces/favorite'
import { createCrudService } from '../crud'

const favoriteCrudService = createCrudService<IFavorite, IFavoriteWithRelations>('favorites')

export const createFavorite = (data: IFavorite): Promise<IFavoriteWithRelations> => {
  return favoriteCrudService.create(data)
}

export const countFavorite = (where: Where<IFavorite> = {}): Promise<number> => {
  return favoriteCrudService.count(where)
}

export const getFavorite = (filter: IFilter<IFavorite>): Promise<IFavoriteWithRelations[]> => {
  return favoriteCrudService.get(filter)
}

export const getFavoriteDetail = (id: number, filter: IFilter<IFavorite>): Promise<IFavoriteWithRelations> => {
  return favoriteCrudService.getDetail(id, filter)
}

export const updateFavorite = (id: number, data: IFavorite): Promise<IFavorite> => {
  return favoriteCrudService.update(id, data)
}

export const deleteFavorite = (id: number): Promise<void> => {
  return favoriteCrudService.delete(id)
}

export const toggleFavorite = async (data: IFavorite): Promise<void> => {
  try {
    await api.put(`/favorites/toggle`, data)
  } catch (error: any) {
    handleError(error as Error, 'API/favorite/index.ts', 'toggleFavorite')
  }
}
